<div style="padding-top: 30px;"></div>
<div class="tab-pane" role="tabpanel" id="tipoaprob">
    <fieldset id="agregar_tipoaprob" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                        <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                        <span id="tp_dir_message"></span>
                    </div>
                    <div class="form-horizontal titulo">
                        <div class="form-group" align="left">
                            <div class="col-sm-2">
                                <label for="tipoaprob">Tipo de Solicitud:</label>
                            </div>
                            <div class="col-sm-10" class="inline" style="font-size: 13px">
                                <div class="col-md-2">
                                    <mat-checkbox (change)="add_tipo_aprobacion()" [(ngModel)]="aprobacion.obra_nueva" name="aprobacion" value="SI">OBRA NUEVA</mat-checkbox>
                                </div>
                                <div class="col-md-3">
                                    <mat-checkbox (change)="add_tipo_aprobacion()" [(ngModel)]="aprobacion.ampliacionmayor100m" name="aprobacion" value="SI">AMPLIACION MAYOR A 100 M2</mat-checkbox>
                                </div>
                                <div class="col-md-2">
                                    <mat-checkbox (change)="add_tipo_aprobacion()" [(ngModel)]="aprobacion.alteracion" name="aprobacion" value="SI">ALTERACION</mat-checkbox>
                                </div>
                                <div class="col-md-3">
                                    <mat-checkbox (change)="add_tipo_aprobacion()" [(ngModel)]="aprobacion.reconstruccion" name="aprobacion" value="SI">RECONSTRUCCION</mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>